import React from "react";
import { Modal } from "react-bootstrap";

import { CloseButton } from "components";

import { UpdateWebsiteForm } from "./updateWebsiteForm";

const UpdateWebsiteModal = ({ show, onHide, onConfirm, handleSubmit }) => {
	const handleHide = () => {
		onHide();
	};

	const handleSave = async values => {
		try {
			await onConfirm(values);
		} finally {
			onHide();
		}
	};

	return (
		<Modal
			show={show}
			onHide={handleHide}
			centered
			animation={true}
			size="lg"
		>
			<Modal.Header>
				<Modal.Title>Add Missing Data</Modal.Title>
				<CloseButton onClick={handleHide} />
			</Modal.Header>
			<Modal.Body>
				<div className="modal-form-container">
					<UpdateWebsiteForm handleSave={handleSave} />
				</div>
			</Modal.Body>
		</Modal>
	);
};

export default UpdateWebsiteModal;
